export default __webpack_public_path__ + "static/media/pg-46.b8355b1c.jpg";